import Vue from 'vue';
import { router } from '@router';
import { store } from '@dynameat/store';
import { errorHandler, warnHandler } from '@core/helpers';
import { vuetify } from '@core/plugins/vuetify';
import { Sentry } from '@core/plugins/sentry';
import { plugins } from '@core/plugins';
import App from '../App.vue';

import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader
import 'typeface-roboto/index.css'; // vuetify / material design font
// import 'roboto-fontface/css/roboto/roboto-fontface.css';

Vue.config.productionTip = false;
Vue.config.errorHandler = errorHandler;
Vue.config.warnHandler = warnHandler;

new Vue({
  i18n: plugins.i18n,
  router,
  store,
  vuetify,
  Sentry,
  render: (h) => h(App)
}).$mount('#app');
